@let i18n = translate();
@let testIdPrefix = 'rcp-confirm-dialog';

@if (data.title) {
    <h2
        mat-dialog-title
        class="!rcp-flex !rcp-items-center !rcp-justify-between !rcp-pt-6 before:!rcp-hidden"
        [attr.data-testid]="testIdPrefix + '-title'"
    >
        {{ data.title }}
        @if (data.headerCloseButton) {
            <button
                mat-icon-button
                aria-label="close dialog"
                mat-dialog-close
                type="button"
            >
                <mat-icon>close</mat-icon>
            </button>
        }
    </h2>
}
<mat-dialog-content>
    <p [attr.data-testid]="'message' | testid: testIdPrefix">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions class="!rcp-pb-6">
    <button
        mat-button
        [attr.data-testid]="'close-btn' | testid: testIdPrefix"
        class="{{ data.closeButton?.class }}"
        (click)="onClose($event)"
    >
        {{
            data.closeButton?.displayText
                ? data.closeButton?.displayText
                : i18n.ACTION__No
        }}
    </button>
    <button
        mat-flat-button
        [attr.data-testid]="'confirm-btn' | testid: testIdPrefix"
        class="{{ data.confirmButton?.class }}"
        (click)="onYesClick($event)"
    >
        {{
            data.confirmButton?.displayText
                ? data.confirmButton?.displayText
                : i18n.ACTION__Yes
        }}
    </button>
</mat-dialog-actions>
